import React from "react";
import { createRoot } from "react-dom/client";
import { ScholarFlowApp } from "../app/ScholarFlowApp";
import "../app/globals.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ScholarFlowApp />
  </React.StrictMode>,
);
